module.exports = __webpack_public_path__ + "b2cd7c86b45c8e5538e287db9a2c5b44.MP3";